import Basket from "@sunrooms/webshop/js/basket/basket";
import ProductAmountInput from '../../../../components/product/amount-input';

class CustomBasket extends Basket {
	setupListeners() {
		super.setupListeners();
		new ProductAmountInput({
			scope : 'div.winkelwagen-wrapper'
		});
	}
}

export default CustomBasket;